import { authRequest } from "src/engine/modules/authRequest"
import get from "lodash/get"
import { showToast } from "@infotech/uikit-toasts"

export const changeStatuses = ({
  events,
  toggleModal,
  setMassiveTransitions,
  setNewStatus,
}) => {
  authRequest({
    url: `/mass-events/transitions`,
    method: `POST`,
    data: { eventUuids: events },
  })
    .then(({ data }) => {
      setMassiveTransitions(data)
      setNewStatus({
        value: get(data, `transitionsTo[0].code`, null),
        label: get(data, `transitionsTo[0].name`, null),
      })
      if (get(data, `transitionsTo.length`)) {
        toggleModal(true)
      } else {
        showToast({
          type: `warning`,
          message: `Перевод в другой статус невозможен.`,
          hideIn: 5,
        })
      }
    })
    .catch(error => {
      showToast({
        type: `warning`,
        message: get(error, `response.data.exception`),
        hideIn: 5,
      })
    })
}

export const massEvents = ({
  events,
  newStatus,
  setInvalidRows,
  resetStates,
  resetFilters,
}) => {
  authRequest({
    url: `/mass-events/status`,
    method: `POST`,
    data: { eventUuids: events, statusCode: newStatus.value },
  })
    .then(
      ({
        data: {
          failedEvents,
          totalCount,
          to: { name },
        },
      }) => {
        const countFailed = failedEvents.length
        const countSuccess = totalCount - failedEvents.length
        if (countSuccess > 0) {
          showToast({
            type: `success`,
            message: `${countSuccess} из ${totalCount} события успешно переведены в статус «${name}».`,
            hideIn: 5,
          })
        }
        if (countFailed > 0) {
          showToast({
            type: `error`,
            message: `${countFailed} из ${totalCount} события не переведены в статус «${name}».`,
            hideIn: 5,
          })
        }
        resetFilters()
        resetStates()
        setInvalidRows(failedEvents)
      },
    )
    .catch(error => {
      showToast({
        type: `error`,
        message: get(error, `response.data.exception`),
        hideIn: 5,
      })
    })
  return []
}
